import React, { useState } from 'react';
import Tooltip from 'rc-tooltip';
import * as S from './styles';
import { Flex, Text, Box } from './components';

function OptionalShortText({ props }) {
  const [autoAssign, setAutoAssign] = useState(props.temporaryDisableRequired || false);

  const onCheckAutoAssign = (checked) => {
    setAutoAssign(checked);

    props.onSetTemporaryDisableRequired({ name: props.name, checked });
  };

  const overlay = (
    <Box width={300}>
      If your templates in ADP have the option to auto-assign a file number to a new employee, you can select this option. When Workstream sends a new employee to ADP, ADP will assign them a file number.
      <Box mb={2} />
      If you do not have this option enabled inside ADP but check this box, new employees that Workstream sends to ADP will not have a file number and you will need to add one manually in ADP.
    </Box>
  );

  return (
    <Flex flexDirection="column">
      <Flex>
        <S.Input
          {...props}
          disabled={props.disabled || autoAssign}
          type="text"
          onChange={(e) => {
            props.onChange({ name: props.name, value: e.target.value });
          }}
        />
      </Flex>
      <Box mb={1} />
      <Flex>
        <Flex alignItems="center">
          <input
            disabled={props.disabled}
            type="checkbox"
            checked={autoAssign}
            onChange={(e) => {
              onCheckAutoAssign(e.target.checked);
            }}
          />
          <Box mr={1} />
          <Tooltip overlay={overlay} placement="top">
            <Text fontSize="12px" semibold>
              Let ADP auto assign this number
            </Text>
          </Tooltip>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default OptionalShortText;
